import { post } from '@/api/http'
import { jsFn } from '@/utils/jsFn'
import profile from '@/utils/profile'
let hostname = window.location.hostname
var serverLocation = jsFn.isCN() ? 'cn' : 'global'

if(hostname.indexOf('-rc') > 0) {
    serverLocation += 'rc'
}

if(hostname.indexOf('localhost') === 0) {
    serverLocation = 'globalrc'
}

var clientID = profile.clientID[serverLocation]
var apiUrl = profile.apiUrl[serverLocation]
export default {
    /** 大雲快速登入 */
    codeLogin: function(code) {
        return new Promise((resolve, reject) => {
            let data = {
                client_id: clientID,
                grant_type: 'authorization_code',
                code: code
            }
            post(apiUrl + '/oauth2/token', data).then(res => {
                if (res.error) {
                    reject(res)
                } else {
                    resolve(res)
                }
            }, err => {
                reject(err)
            })
        })
    },
    /** 帳號密碼登入 */
    accLogin: function(item) {
        return new Promise((resolve, reject) => {
            let nonceStr = jsFn.getUUID()
            // 開頭有0要去0
            let re = /^[0-9]+$/
            if (re.test(item.id) && item.id.toString().indexOf(0) === 0) {
                item.id = item.id.substr(1)
            }
            let data = {
                client_id: clientID,
                grant_type: 'account',
                account: item.id,
                password: item.pass,
                nonce: nonceStr
            }
            
            post(apiUrl + '/oauth2/login', data).then(res => {
                if (res.error) {
                    reject(new Error(res))
                } else {
                    let tData = jsFn.jwtDecode(res.id_token)
                    if (nonceStr === tData.nonce) {
                        resolve(res)
                    } else {
                        let result = {
                            error: 10001,
                            message: '錯誤登入'
                        }
                        reject(result)
                    }
                }
            }, err => {
                reject(err)
            })
        })
    },
    /** 取得快速登入code */
    getCode: function(tokens) {
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let nonceStr = jsFn.getUUID()
            let data = {
                client_id: clientID,
                grant_type: 'code',
                id_token: tokens.id_token,
                nonce: nonceStr
            }
            post(apiUrl + '/oauth2/login', data, headers).then(res => {
                if (res.error) {
                    reject(new Error(res))
                } else {
                    resolve(res)
                }
            }, err => {
                reject(err)
            })
        })
    },
    /** 取得詳細使用者資訊 */
    getUserInfo: function(tokens) {
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let nonceStr = jsFn.getUUID()
            let data = {
                grant_type: 'get',
                client_id: clientID,
                id_token: tokens.id_token,
                nonce: nonceStr
            }
            post(apiUrl + '/oauth2/profile', data, headers).then(res => {
                if (res.error) {
                    reject(new Error(res))
                } else {
                    if (nonceStr === jsFn.jwtDecode(res.id_token).nonce) {
                        resolve(res)
                    } else {
                        resolve({
                            error: 'nonce'
                        })
                    }
                }
            }, err => {
                reject(err)
            })
        })
    },
    /** 更新個人資訊API */
    tmdProfile: function(tokens, grantType, item) {
        return new Promise((resolve, reject) => {
            const grantTypes = { get: 'get',name: 'name' };

            let nonceStr = jsFn.getUUID()
            let data = {
                grant_type: grantType,
                client_id: clientID,
                id_token: tokens.id_token,
                nonce: nonceStr
            }

            switch(grantType) {
                case grantTypes.get:
                break
                case grantTypes.name:
                    data.name = item 
                break
                default:
                    resolve({error: 'grantType error'})
            }

            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            
            post(apiUrl + '/oauth2/profile', data, headers).then(res => {
                if (res.error) {
                    reject(new Error(res))
                } else {
                    if (nonceStr === jsFn.jwtDecode(res.id_token).nonce) {
                        resolve(res)
                    } else {
                        resolve({
                            error: 'nonce'
                        })
                    }
                }
            }, err => {
                reject(err)
            })
        })
    },
    /** 取得使用者進階聯絡資訊 */
    getContact: function(tokens) {
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let data = {
                grant_type: 'get',
                product: 'base-ex',
                id_token: tokens.id_token
            }
            post(apiUrl + '/oauth2/usersetting', data, headers).then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    /** 取得使用者進階聯絡資訊 */
    setContact: function(tokens, item){
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let data = {
                grant_type: 'add',
                id_token: tokens.id_token
            }

            let keys = Object.keys(item)
            keys.forEach( k=> {
                data[k] = item[k]
            })

            if(data.countryCode && data.mobile){
                data.mobile = `+${data.countryCode}-${data.mobile}`
                delete data.countryCode
            }

            post(apiUrl + '/oauth2/contact', data, headers).then(() => {
                resolve(true)
            }, err => {
                reject(err)
            })
        })
    },
    /** 兌換獎勵 */
    benifits: function(tokens, eventNum) {
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let data = {
                id_token: tokens.id_token,
                num : eventNum
            }
            post(apiUrl + '/oauth2/Benefits', data, headers).then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    /** 取得優惠卷 */
    getCoupon: function(tokens, coupon) {
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let data = {
                id_token: tokens.id_token,
                coupon : coupon
            }
            post(apiUrl + '/oauth2/ExchangeCoupon', data, headers).then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    /** 兌換優惠卷 */
    exchangeVoucher: function(tokens, voucher) {
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let data = {
                id_token: tokens.id_token,
                voucher : voucher
            }
            post(apiUrl + '/oauth2/ExchangeVoucher', data, headers).then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    /** 取得使用者設定檔 */
    getUsersetting: function(tokens, product) {
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let data = {
                grant_type: 'get',
                product: product,
                id_token: tokens.id_token
            }
            post(apiUrl + '/oauth2/usersetting', data, headers).then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    /** 設定使用者設定檔 */
    setUsersetting: function(tokens, data) {
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let tmp = {
                grant_type: 'update',
                id_token: tokens.id_token,
                data: data
            }
            post(apiUrl + '/oauth2/usersetting', tmp, headers).then(() => {
                resolve(true)
            }, err => {
                reject(err)
            })
        })
    },
    /** 取得使用者優惠券明細 */
    getCouponDetail: function(tokens) {
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let data = {
                grant_type: 'get',
                product: 'mynews',
                id_token: tokens.id_token
            }
            post(apiUrl + '/oauth2/usersetting', data, headers).then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    /**取得學校列表 */
    getSchoolData: function(tokens, item) {
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let data = {
                countryId: item.country
            }

            if(item.country == 'TW'){
                data.cityId = item.province
            } else {
                data.provinceId = item.province
                data.cityId = item.city
            }

            post(apiUrl + '/service/schoolData', data, headers).then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    /**取得推薦碼 */
    getReferralInfo: function(tokens) {
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let data = {
                id_token: tokens.id_token,
            }
            post(apiUrl + '/oauth2/GetReferralCode', data, headers).then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    /** 兌換推薦碼*/
    applyReferralCode: function(tokens, code) {
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token
                }
            }
            let data = {
                id_token: tokens.id_token,
                referralCode: code
            }
            post(apiUrl + '/oauth2/ApplyReferralCode', data, headers).then(res => {
                if(res.error) {
                    reject(res)
                } else {
                    resolve(res)
                }
            }, err => {
                reject(err)
            })
        })
    },
    /** 刷新token */
    refreshToken: function(access_token) {
        return new Promise((resolve, reject) => {
            post(apiUrl + '/oauth2/token', {
                grant_type: 'refresh_token',
                client_id: clientID,
                access_token: access_token
            }).then(
                res => {
                    resolve(res)
                }, (err) => {
                    reject(err)
                }
            )
        })
    }
}
